import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { LoginForm } from '@/components/auth/login-form';
import { RegisterForm } from '@/components/auth/register-form';
import { X } from 'lucide-react';
import { useState } from 'react';
import { useLocation } from 'wouter';
import { ENABLE_REGISTRATION } from '@/utils/env-setup';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  defaultTab?: 'login' | 'register';
}

export function AuthModal({ isOpen, onClose, defaultTab = 'login' }: AuthModalProps) {
  const [activeTab, setActiveTab] = useState<string>(defaultTab);
  const [_, navigate] = useLocation();

  const handleSuccess = () => {
    onClose();
    navigate('/dashboard');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px] max-h-[90vh] overflow-y-auto z-[9999]">
        <DialogHeader className="flex justify-between items-center">
          <DialogTitle className="text-xl">
            {activeTab === 'login' ? 'Login to your account' : 'Create an account'}
          </DialogTitle>
          {/* Removed extra X button since there's already an X in the top right corner */}
        </DialogHeader>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="mt-4">
          {/* Only show tabs if registration is enabled, otherwise just show the content */}
          {ENABLE_REGISTRATION && (
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger value="login">Login</TabsTrigger>
              <TabsTrigger value="register">Register</TabsTrigger>
            </TabsList>
          )}
          <TabsContent value="login" className="mt-6">
            <LoginForm
              onSuccess={handleSuccess}
              onSwitchToRegister={() => setActiveTab('register')}
            />
          </TabsContent>
          {ENABLE_REGISTRATION && (
            <TabsContent value="register" className="mt-6">
              <RegisterForm
                onSuccess={handleSuccess}
                onSwitchToLogin={() => setActiveTab('login')}
              />
            </TabsContent>
          )}
        </Tabs>
      </DialogContent>
    </Dialog>
  );
}
